<template>
  <v-list class="list-container">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>User ID</v-list-item-title>
        <v-list-item-subtitle>{{
          customerRecord.userToken
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>{{
          `${customerRecord.firstName} ${customerRecord.lastName}`
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>{{
          customerRecord.phoneNumber
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>{{ customerRecord.email }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="tariffs">
      <v-list-item-content>
        <v-list-item-subtitle v-for="tariff in tariffs" v-bind:key="tariff">
          {{ tariff }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>{{ customerRecord.city }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="customerRecord.bankAccountNumber">
      <v-list-item-content>
        <v-list-item-subtitle>{{
          customerRecord.bankAccountNumber
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="customerRecord.payoutType === 'cash'">
      <v-list-item-content>
        <v-list-item-subtitle>Выплата наличными</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="customerRecord.applications.length > 0">
      <v-list-item-content>
        <v-list-item-subtitle>{{
          customerRecord.applications.join(', ')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="mandateContractInfo" two-line>
      <v-list-item-content>
        <v-list-item-subtitle>{{ mandateContractInfo }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="vehicleInfo">
      <v-list-item-content>
        <v-list-item-subtitle>{{ vehicleInfo }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { AGREEMENT_TYPE } from '@/models/finex';
import {
  mapMandateContractType,
  mapMandateContractTime,
  mapTariffs,
} from '@/mappers/finex';

export default {
  name: 'CustomerRecord',

  props: {
    customerRecord: Object,
  },

  computed: {
    mandateContractInfo() {
      const mandateContractData = this.customerRecord?.signedAgreements?.find(
        ({ type }) => type === AGREEMENT_TYPE.MANDATE_CONTRACT_AGREEMENT
      );
      if (!mandateContractData) return null;

      const mandateContractType = mapMandateContractType(
        mandateContractData.mandateContractType
      );
      const mandateContractTime = mapMandateContractTime(
        mandateContractData.time
      );

      return `${mandateContractType} - ${mandateContractTime}`;
    },

    vehicleInfo() {
      const { vehicleModel, vehicleNumber } = this.customerRecord;
      if (!(vehicleModel || vehicleNumber)) {
        return null;
      }

      const model = vehicleModel || 'Нет даных о модели';
      const number = vehicleNumber || 'Нет даных о номерном знаке';

      return `${model} - ${number}`;
    },

    tariffs() {
      const { subscriptions } = this.customerRecord;
      if (subscriptions?.length === 0) {
        return null;
      }

      return mapTariffs(subscriptions);
    },
  },
};
</script>
<style lang="scss">
.list-container {
  .v-list-item {
    min-height: 36px;
    padding: 0;

    &__content {
      padding: 6px 0;

      div {
        font-size: 16px;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: break-word;
      }
    }

    &.theme--light {
      div {
        color: #000 !important;
      }
    }

    &.theme--dark {
      div {
        color: #fff !important;
      }
    }
  }
}
</style>
